import React from "react";
import Star from "@mui/icons-material/Star";
import StarBorder from "@mui/icons-material/StarBorder";

interface StarRatingProps {
  rating: number;
}

const StarRating: React.FC<StarRatingProps> = ({ rating }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(
      i <= rating ? (
        <Star key={i} style={{ color: "#ffc107", height: "25px", width: "25px" }} />
      ) : (
        <StarBorder key={i} style={{ color: "#e4e5e9", height: "25px", width: "25px" }} />
      )
    );
  }
  return <div>{stars}</div>;
};

export default StarRating;
